module.exports = __webpack_public_path__ + "static/header-0ff10f4bc702011ad4f7c6654b42585f.jpg";